export default "__VITE_ASSET__CtVTbTZL__"